import { PUT_REVIEW_START, PUT_REVIEW_SUCCESS, PUT_REVIEW_FAILURE } from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const putReview = makeAsyncReducer(
  { startType: PUT_REVIEW_START, successType: PUT_REVIEW_SUCCESS, failureType: PUT_REVIEW_FAILURE },
  { initialData: {} }
);

export const putReviewSelector = (state) => state.ratingReviews.putReview;
